import { STUDY_STATUSES } from '$app-web/constants';
import { isChatEnabled } from '$app-web/utils';

// Mirrors the wire contract sent by new PDash via CHAT_INIT / CHAT_STUDY_CHANGED.
// Kept as a literal union so typos like "ongoign" fail at compile time.
export type StandaloneStudyStatus = 'ONGOING' | 'UPCOMING' | 'FINISHED' | 'UNKNOWN';

export interface StandaloneStudy {
    name: string;
    hasParticipantChat: boolean;
    hasVideoChat: boolean;
    hasVoiceChat: boolean;
    status: StandaloneStudyStatus;
}

export type StandaloneStudiesMap = Record<number, StandaloneStudy>;

export interface ChatFlags {
    isBaseChatEnabledForAtLeastOneStudy: boolean;
    isBaseChatEnabledForCurrentStudy: boolean;
    isVideoChatEnabledForCurrentStudy: boolean;
    isVoiceChatEnabledForCurrentStudy: boolean;
}

export function deriveChatFlags(currentStudyId: number, studies: StandaloneStudiesMap): ChatFlags {
    const current = studies[currentStudyId];
    const isCurrentStudyActive = current?.status === STUDY_STATUSES.ONGOING || current?.status === STUDY_STATUSES.UPCOMING;

    const isBaseChatEnabledForAtLeastOneStudy =
        isChatEnabled() &&
        Object.values(studies).some(
            (study) =>
                study.hasParticipantChat === true &&
                (study.status === STUDY_STATUSES.ONGOING || study.status === STUDY_STATUSES.UPCOMING)
        );

    return {
        isBaseChatEnabledForAtLeastOneStudy,
        isBaseChatEnabledForCurrentStudy: isChatEnabled() && current?.hasParticipantChat === true && isCurrentStudyActive,
        isVideoChatEnabledForCurrentStudy: isChatEnabled() && current?.hasVideoChat === true && isCurrentStudyActive,
        isVoiceChatEnabledForCurrentStudy: isChatEnabled() && current?.hasVoiceChat === true && isCurrentStudyActive,
    };
}

export function buildStudyNameGetter(studies: StandaloneStudiesMap): (studyId: number) => string | undefined {
    return (studyId: number) => studies[studyId]?.name;
}
